export enum InputType {
  text = 'text',
  time = 'time',
  number = 'number',
  select = 'select',
}
